/** Die Ansicht »Fällige Prüfungen«: Filter, Seiten, Nachladen. */

import { useInfiniteQuery } from '@tanstack/react-query'
import { api } from './klient'
import type { Aufgabenstatus } from './aufgaben'
import type { Pruefart } from './typen'

export type Faelligkeitszeile = {
  id: string
  spielplatz_id: string
  spielplatz_name: string
  spielplatz_kennung: string | null
  ort: string | null
  plz: string | null
  kunde_id: string
  kunde_name: string
  pruefart: Pruefart
  faellig_am: string
  status: Aufgabenstatus
  zugewiesen_an_name: string | null
  letzte_pruefung_am: string | null
  /** Negativ heißt überfällig. Im Server gerechnet, nicht im Browser. */
  tage_bis_faellig: number
}

export type Faelligkeitsseite = {
  zeilen: Faelligkeitszeile[]
  weiter: string | null
  anzahl: number
  mehr_als: boolean
  heute: string
}

export type Zeitraum = 'ueberfaellig' | 'woche' | 'monat' | 'frei'

export type Faelligkeitsfilter = {
  zeitraum?: Zeitraum
  von?: string
  bis?: string
  kunde_id?: string
  pruefart?: Pruefart
  ort?: string
  pruefer_id?: string
  suche?: string
  alle_zustaende?: boolean
}

export function alsSuchtext(f: Faelligkeitsfilter): string {
  const teile = new URLSearchParams()
  for (const [name, wert] of Object.entries(f)) {
    if (wert === undefined || wert === '' || wert === false) continue
    teile.set(name, String(wert))
  }
  return teile.toString()
}

export function useFaellige(filter: Faelligkeitsfilter) {
  const suchtext = alsSuchtext(filter)
  return useInfiniteQuery({
    queryKey: ['faellig', suchtext] as const,
    initialPageParam: '',
    queryFn: ({ pageParam, signal }) => {
      const teile = new URLSearchParams(suchtext)
      if (pageParam) teile.set('ab', pageParam as string)
      return api.holen<Faelligkeitsseite>(
        `/api/aufgaben/faellig?${teile.toString()}`,
        signal,
      )
    },
    // Leer heißt: das war die letzte Seite.
    getNextPageParam: (letzte) => letzte.weiter ?? undefined,
  })
}
